// Çevre değişkenleri için merkezi bir yapılandırma
export const API_URL = process.env.REACT_APP_API_URL || 'https://akademikadro.net/api'; 